export default __webpack_public_path__ + "static/media/chevron-right.c373433e.svg";